import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { useAccessToken } from '@/services/auth';
import { stringMapOptions } from '@/services/lookup';

const STRING_MAPS = {
  donor_schedule_export: { name: 'tog_export', objectTypeCode: 10081 },
  donor_schedule_implant_type: {
    name: 'tog_implanttype',
    objectTypeCode: 10081,
  },
  donor_schedule_semen_type: { name: 'tog_sementype', objectTypeCode: 10081 },
  shipment_status: { name: 'tog_shpmentstatus', objectTypeCode: 10089 },
  shipping_method: { name: 'tog_shippingmethod', objectTypeCode: 10089 },
} as const;

export type StringMapOption = {
  label: string;
  value: number;
};

export function useStringMap(mapName: keyof typeof STRING_MAPS) {
  const token = useAccessToken();
  const stringMap = STRING_MAPS[mapName];
  const res = useQuery(
    stringMapOptions(token, stringMap.objectTypeCode, stringMap.name),
  );
  const options = useMemo(
    () =>
      res.data?.map((item) => ({
        label: item.value ?? '',
        value: item.key,
      })) satisfies StringMapOption[] | undefined,
    [res.data],
  );

  if (options) {
    return {
      type: 'success' as const,
      options,
    };
  }

  if (res.error) {
    return { type: 'error' as const, error: res.error };
  }

  return { type: 'loading' as const, loading: true };
}
